export const normalizeProductionLosses = (losses = {}) => {
  let source = losses;
  if (typeof source === 'string') {
    try {
      source = JSON.parse(source);
    } catch {
      return null;
    }
  }
  if (!source || typeof source !== 'object') {
    return null;
  }

  const pick = (...keys) => {
    for (let index = 0; index < keys.length; index += 1) {
      const key = keys[index];
      if (source[key] !== undefined && source[key] !== null) {
        return source[key];
      }
    }
    return undefined;
  };
  const normalized = {};
  const setIfFinite = (key, value) => {
    const number = Number(value);
    if (Number.isFinite(number)) normalized[key] = number;
  };

  setIfFinite('soiling', pick('Soiling', 'soiling'));
  setIfFinite('shading', pick('Shading', 'shading'));
  setIfFinite('snow', pick('Snow', 'snow'));
  setIfFinite('mismatch', pick('Mismatch', 'mismatch'));
  setIfFinite('wiring', pick('Wiring', 'wiring'));
  setIfFinite('connections', pick('Connections', 'connections'));
  setIfFinite(
    'lid',
    pick('Light_Induced_Degradation', 'lid', 'light_induced_degradation')
  );
  setIfFinite(
    'nameplate_rating',
    pick('Nameplate_Rating', 'nameplate_rating', 'nameplateRating')
  );
  setIfFinite('age', pick('Age', 'age'));
  setIfFinite('availability', pick('Availability', 'availability'));

  return Object.keys(normalized).length ? normalized : null;
};
